import { get } from 'lodash';
import { DateTime } from 'luxon';
export const isPriceRuleValid = (membership, rule, subscriptionCreatedDate, subscriptionSwitchedDate) => {
    const untilDate = new Date(rule.options.validUntil);
    const checkDate = membership.lastIndexOf('%') !== -1
        ? untilDate.setDate(untilDate.getDate() - 1)
        : subscriptionSwitchedDate || subscriptionCreatedDate;
    if (membership && rule.options) {
        const membershipExists = rule.options.label && rule.options.label.toLowerCase().includes(stripVersion(membership).toLowerCase());
        const validFrom = !rule.options.validFrom || checkDate > new Date(rule.options.validFrom);
        const validUntil = !rule.options.validUntil || checkDate < new Date(rule.options.validUntil);
        if (validFrom && validUntil) {
            return membershipExists;
        }
    }
    return false;
};
export const isGlobalCartRule = (rule) => {
    return rule.options && rule.options.label === 'CartDiscount';
};
export const shouldApplyEmployeeDiscount = (rule, options) => {
    return (rule.options &&
        rule.options.label === 'SunsetPlusForEmployees' &&
        options.employeeDiscountToken &&
        options.employeeDiscountToken.token &&
        new Date(options.employeeDiscountToken.expiresAt) > new Date());
};
export const shouldApplySunsetPointsDiscount = (rule, options) => {
    return (rule.options &&
        rule.options.label === 'SunsetPoints' &&
        options.sunsetPoints &&
        options.sunsetPoints.totalPoints > 0);
};
export const stripVersion = function (str) {
    if (str.indexOf(' %') !== -1) {
        const adjustedStr = str.replace(' %', '%');
        return adjustedStr.lastIndexOf(' ') !== -1 ? str.substr(0, adjustedStr.lastIndexOf(' ')) : str;
    }
    return str.lastIndexOf(' ') !== -1 && str.lastIndexOf('%') !== -1 ? str.substr(0, str.lastIndexOf(' ')) : str;
};
export const getShopPattern = (shopPattern) => {
    return !shopPattern || Array.isArray(shopPattern) ? shopPattern : shopPattern.list;
};
export const getIsWhitelist = (shopPattern) => {
    return !shopPattern || Array.isArray(shopPattern) ? true : shopPattern.isWhitelist;
};
export const shouldRuleBeAppliedToShop = (shopPattern, shopId) => {
    const shopsList = getShopPattern(shopPattern);
    const isWhitelist = getIsWhitelist(shopPattern);
    if (shopPattern && typeof shopPattern === 'object' && !Array.isArray(shopPattern)) {
        if (Array.isArray(shopsList) && shopsList.length > 0) {
            return isWhitelist
                ? shopsList.find((s) => s && s.indexOf(shopId) !== -1)
                : !shopsList.find((s) => s && s.indexOf(shopId) !== -1);
        }
        return !isWhitelist;
    }
    return (!shopsList ||
        (Array.isArray(shopsList) && (shopsList.includes(shopId) || shopsList.includes('*') || shopsList.includes('*-*-*'))));
};
export const getProductSpecificDiscount = ({ price, discount }) => {
    const discountValue = parseInt(discount.discountValue);
    if (discount.discountType === 'percentDiscount') {
        return (discountValue * price) / 100;
    }
    if (discount.discountType === 'simpleDiscountFixedAmount') {
        return discountValue;
    }
    return 0;
};
export const isProductSpecificDiscount = (discount) => discount &&
    (!discount.voucherPattern || !discount.voucherPattern.length) &&
    ['simpleDiscountFixedAmount', 'percentDiscount'].includes(discount.discountType)
    ? true
    : false;
export const isFreeMealPriceRule = (rule) => get(rule, 'options.label', '').startsWith('FreeMeal:');
export const isRuleActive = (rule, pickupTimeZone = null) => {
    if (!Array.isArray(rule.timePattern) || rule.timePattern.length === 0) {
        return true;
    }
    const nowLuxon = DateTime.now().setZone(pickupTimeZone);
    const currentWeekDay = nowLuxon.weekday;
    if (!Array.isArray(rule.weekDay) || !rule.weekDay.includes(currentWeekDay)) {
        return false;
    }
    const nowSeconds = nowLuxon.hour * 3600 + nowLuxon.minute * 60 + nowLuxon.second;
    const inRange = rule.timePattern.some(({ startTime, endTime }) => {
        const [startHour, startMinute = 0, startSecond = 0] = startTime.split(':').map(Number);
        const [endHour, endMinute = 0, endSecond = 0] = endTime.split(':').map(Number);
        const startSeconds = startHour * 3600 + startMinute * 60 + startSecond;
        const endSeconds = endHour * 3600 + endMinute * 60 + endSecond;
        return nowSeconds >= startSeconds && nowSeconds <= endSeconds;
    });
    return inRange;
};
export const isRuleWithTimePatternActive = (timePattern, pickupTimeZone = null) => {
    if ((timePattern === null || timePattern === void 0 ? void 0 : timePattern.length) === 0) {
        return true;
    }
    if (!Array.isArray(timePattern)) {
        return false;
    }
    const nowLuxon = DateTime.now().setZone(pickupTimeZone);
    const nowSeconds = nowLuxon.hour * 3600 + nowLuxon.minute * 60 + nowLuxon.second;
    const inRange = timePattern.some(({ startTime, endTime }) => {
        if (!startTime || !endTime)
            return false;
        const [startHour, startMinute = 0, startSecond = 0] = startTime.split(':').map(Number);
        const [endHour, endMinute = 0, endSecond = 0] = endTime.split(':').map(Number);
        const startSeconds = startHour * 3600 + startMinute * 60 + startSecond;
        const endSeconds = endHour * 3600 + endMinute * 60 + endSecond;
        if (endSeconds >= startSeconds) {
            return nowSeconds >= startSeconds && nowSeconds <= endSeconds;
        }
        return nowSeconds >= startSeconds || nowSeconds <= endSeconds;
    });
    return inRange;
};
